const prefetchedPages = new Set()

const getPrefetchLink = (target) => {
  if (!(target instanceof Element)) return null
  return target.closest('[data-prefetch-project]')
}

const prefetchProjectPage = (url) => {
  if (!url || prefetchedPages.has(url)) return

  prefetchedPages.add(url)

  if (document.querySelector(`link[rel="prefetch"][href="${url}"]`)) return

  const link = document.createElement('link')
  link.rel = 'prefetch'
  link.href = url
  link.as = 'document'
  document.head.appendChild(link)
}

const handlePrefetchIntent = (event) => {
  const anchor = getPrefetchLink(event.target)

  if (!anchor?.href) return

  prefetchProjectPage(anchor.href)
}

export const initProjectPagePrefetch = () => {
  if (initProjectPagePrefetch.initialized) return

  document.addEventListener('pointerenter', handlePrefetchIntent, true)
  document.addEventListener('focusin', handlePrefetchIntent, true)
  initProjectPagePrefetch.initialized = true
}

initProjectPagePrefetch.initialized = false
